import { render, staticRenderFns } from "./MarkAsSelector.vue?vue&type=template&id=00ab5af2&scoped=true&"
import script from "./MarkAsSelector.vue?vue&type=script&lang=js&"
export * from "./MarkAsSelector.vue?vue&type=script&lang=js&"
import style0 from "./MarkAsSelector.vue?vue&type=style&index=0&id=00ab5af2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00ab5af2",
  null
  
)

export default component.exports